import { useState } from "react";
import { FiX, FiSave } from "react-icons/fi";
import ShowEditor from "../ShowEditor"
import Button from "../ui/Button";

export default function ShowEditorModal({onClose, show}) {
    const [newShow, setNewShow] = useState(show || {
        name: 'New Show',
        description: ''
    })

    return (
        <div className='w-full h-full max-w-[500px] flex flex-col bg-background border-l'>
            <div className='flex justify-between py-2 px-4 items-center'>
                <span className='text-white text-lg font-bold'>{show ? 'Edit' : 'New'} Show</span>
                <div className='cursor-pointer text-gray-400 hover:text-white' onClick={() => onClose(null)}><FiX className="w-6 h-6" /></div>
            </div>
            <div className='flex-1 overflow-hidden flex flex-col'>
                <ShowEditor defaultValue={newShow} onChange={(show) => setNewShow(show)} />
            </div>
            <div className='flex p-4 gap-4 '>
                <Button type='primary' className='min-w-20' onClick={() => onClose(newShow)}>Save</Button>
                <Button type='danger-ghost' className='min-w-20' onClick={() => onClose(null)}>Cancel</Button>
            </div>
        </div>
    )
}